export * from '@fhs/routing/src/routes/v2/cart/_layout';
export { default } from '@fhs/routing/src/routes/v2/cart/_layout';
